import webApi, { baseURL } from "./WebApi/WebApi";

export const getDistrictList = async () => {
    return await webApi.post(`/api/GetDistrict`,);
}
export const getBlockList = async (data) => {
    return await webApi.post(`/api/GetBlock/${data}`,);
}
export const getGpList = async (data) => {
    return await webApi.post(`/api/GetGP/${data}`,);
}
export const getSansadList = async (data) => {
    return await webApi.post(`/api/GetSansad/${data}`,);
}
export const getVillageList = async (dist_lgd, blk_lgd, gp_lgd) => {
    return await webApi.post(`/api/GetVillageByAll/${dist_lgd}/${blk_lgd}/${gp_lgd}`,);
}
export const getCertificateList = async (data) => {
    return await webApi.get(`/api/CERTIFICATE/GetCertificateList`,);
}
export const getCertificateDocumentList = async (char_cert, incm_cert, resi_cert, sper_cert, dist_cert, cast_cert, id) => {
    return await webApi.get(`/api/CERTIFICATE/GetDocumentList/${char_cert}/${incm_cert}/${resi_cert}/${sper_cert}/${dist_cert}/${cast_cert}/${id}`,);
}
export const getCertificateDocumentList2 = async (char_cert, incm_cert, resi_cert, sper_cert, dist_cert, cast_cert, id) => {
    return await webApi.get(`/api/CERTIFICATE/GetDocumentList/${char_cert}/${incm_cert}/${resi_cert}/${sper_cert}/${dist_cert}/${cast_cert}/${id}`,);
}

export const postNumberVerification = async (mobile, onSuccess, onFailure) => {

    try {
        const res = await webApi.post(
            `/api/CERTIFICATE/InsertMobile`, {
            mobile_no: parseInt(mobile),
        });
        console.log(res.data, "resresrese")
        if (res?.data?.StatusCode == 0) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("error")
    }
};

export const postOtpVerification = async (mobile, otp, onSuccess, onFailure) => {

    try {
        const res = await webApi.post(
            `/api/CERTIFICATE/GetMobile`, {
            mobile_no: parseInt(mobile),
            otp_value: parseInt(otp),
        });
        console.log(res.data, "resresrese")
        if (res?.data?.StatusCode == 0) {
            const r = res.data;
            return onSuccess(r);
        } else if (res?.data?.StatusCode == 1) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("error")
    }
};

//insert certificate

export const postCertificate = async (district, block, gp, sansad, assesseeNo, assesseeName, aplicantName, relation,
    guardianName, relationWithGuardian, address, policeStation, postOffice, village,
    pin, dob, gender, certificate, mobile, getMobileNumber, getEmailInput, char_cert, incm_cert, resi_cert, sper_cert,
    dist_cert, incm_source, incm_annual, resi_distance, resi_location, sper_old_name, sper_curr_name,
    document1, uniqueNo1, base64String, document2, uniqueNo2, base64String2,
    previewImage, bengAplicantName, bengGuardianName, bengRelationWithGuardian, bengAddress, bengPostOffice, bengPoliceStation, bengVillage, bengPin, bengDob,
    cast_cert, religion, caste, subCaste, uniqueNo3, base64String3, oth_lang, Unmarried, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/api/CERTIFICATE/InsertCertificate`,
            {
                "dist_lgd": district,
                "blk_lgd": block,
                "gp_lgd": gp,
                "sansad_no": sansad,
                "assee_no": assesseeNo ? assesseeNo : "",
                "assee_name": assesseeName ? assesseeName : "",
                "applicant_name": aplicantName,
                "rel_assee": relation ? relation : "",
                "gurdian_name": guardianName,
                "rel_gurdian": relationWithGuardian,
                "addr": address,
                "police_station": policeStation,
                "post_office": postOffice,
                "village": village,
                "pin": pin,
                "dob": dob,
                "gender": gender,
                "cert_type": certificate,
                "mobile": mobile,
                "whatsapp": getMobileNumber,
                "email": getEmailInput,

                "char_cert": char_cert,
                "incm_cert": incm_cert,
                "resi_cert": resi_cert,
                "sper_cert": sper_cert,
                "dist_cert": dist_cert,
                "incm_source": incm_source,
                "incm_annual": incm_annual,
                "resi_distance": resi_distance,
                "resi_location": resi_location,
                "sper_old_name": sper_old_name,
                "sper_curr_name": sper_curr_name,


                "doc_type1": document1,
                "doc_no1": uniqueNo1,
                "doc_type2": document2,
                "doc_no2": uniqueNo2,
                "Base64File1": base64String,
                "Base64File2": base64String2,

                "prof_img_Base64File": previewImage,
                "name_ben": bengAplicantName ? bengAplicantName : "",
                "relt_ass_ben": "",
                "name_gurdian_ben": bengGuardianName ? bengGuardianName : "",
                "relt_gurdian_ben": bengRelationWithGuardian ? bengRelationWithGuardian : "",
                "address_ben": bengAddress ? bengAddress : "",
                "post_office_ben": bengPostOffice ? bengPostOffice : "",
                "police_station_ben": bengPoliceStation ? bengPoliceStation : "",
                "village_ben": bengVillage ? bengVillage : "",
                "pin_ben": bengPin ? bengPin : "",
                "dob_ben": bengDob ? bengDob : "",
                "cast_cert": cast_cert,
                "religion": religion ? religion : "",
                "app_cast": caste ? caste : 0,
                "app_sub_cast": subCaste ? subCaste : "",
                "mem_doc_no": uniqueNo3 ? uniqueNo3 : "",
                "mem_doc_base64": base64String3 ? base64String3 : null,
                "oth_lang": oth_lang,
                "Unmarried":Unmarried

            });
        if (res?.data?.StatusCode == 0) {
            const r = res.data;
            return onSuccess(r);
        } else if (res?.data?.StatusCode == 1) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("error")
    }
};


export const getCertificateListForCitizen = async (mobile) => {
    return await webApi.post(`/api/CERTIFICATE/GetApplicantCertificate`,
        { MobileNo: parseInt(mobile), },);
}


export const getCertificateDownload = async (data) => {
    return await webApi.get(`/api/CERTIFICATE/CertificateDownload?app_id=${data}`,);
}

export const getSubCasteCertificate = async (data) => {
    return await webApi.get(`/api/CERTIFICATE/GetSubCast?cast_id=${data}`,);
}


export const getSignature = async (gp_lgd) => {

    return await webApi.get(`api/GetPradhanSignature?gp_lgd=${gp_lgd}
`, {

    });
}


export const getApplicantCertificateAppId = async (data) => {
    return await webApi.get(`/api/CERTIFICATE/GetApplicantCertificateAppId?AppId=${data}`,);
}

export const getApplicantCertificateCheck = async (data) => {
    return await webApi.get(`/api/CERTIFICATE/GetCertificateValid?AppId=${data}`,);
}



export const getCertificateById = async (data) => {
    console.log(data, "datadataataa")
    return await webApi.get(`/api/CERTIFICATE/GetApplicantCertificateAppId?AppId=${data}`, {

    });
}

export const getSummaryReport = async (dist_lgd, block_lgd, gp_lgd, frm_dt, to_dt) => {
    return await webApi.get(`/api/CERTIFICATE/EntryStatus?dist_lgd=${dist_lgd}&block_lgd=${block_lgd}&gp_lgd=${gp_lgd}&frm_dt=${frm_dt}&to_dt=${to_dt}`,);
}